import config from '../config';
import authService from './authService';

function buildQuery(params = {}) {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value === null || value === undefined || value === '') {
      return;
    }
    search.append(key, String(value));
  });
  const query = search.toString();
  return query ? `?${query}` : '';
}

async function get(endpoint, params) {
  const authHeaders = authService.getAuthHeaders();
  const response = await fetch(
    `${config.apiBaseUrl}${endpoint}${buildQuery(params)}`,
    {
      headers: {
        ...authHeaders,
        'Content-Type': 'application/json'
      }
    }
  );

  if (!response.ok) {
    let errorMessage = `Request failed with status ${response.status}`;
    try {
      const errorBody = await response.json();
      if (errorBody?.error) {
        errorMessage = errorBody.error;
      }
    } catch (err) {
      // ignore JSON parse errors; fall back to default message
    }
    throw new Error(errorMessage);
  }

  return response.json();
}

export const reportingService = {
  getCustomerEvents(customerId, params) {
    return get(`/api/reporting/customers/${customerId}/events`, params);
  },
  getCustomerSummary(customerId, params) {
    return get(`/api/reporting/customers/${customerId}/summary`, params);
  },
  getCustomerSeries(customerId, params) {
    return get(`/api/reporting/customers/${customerId}/series`, params);
  },
  getProductEvents(productId, params) {
    return get(`/api/reporting/products/${productId}/events`, params);
  },
  getProductSummary(productId, params) {
    return get(`/api/reporting/products/${productId}/summary`, params);
  },
  getProductSeries(productId, params) {
    return get(`/api/reporting/products/${productId}/series`, params);
  },
  getCustomerRecentActivity(customerId, params) {
    return get(`/api/reporting/customers/${customerId}/recent-activity`, params);
  },
  getProductRecentActivity(productId, params) {
    return get(`/api/reporting/products/${productId}/recent-activity`, params);
  },
  getKeyDetail(apiKeyId, params) {
    return get(`/api/reporting/key`, { apiKeyId, ...params });
  }
};

export default reportingService;

